var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{white:_vm.bg=='white',linear:_vm.bg=='linear'},attrs:{"id":"app"}},[_c('Header'),(_vm.show)?_c('router-view'):_vm._e(),_c('Footer'),_c('Service'),_c('ValidWarn'),_c('Notices')],1)}
var staticRenderFns = []

export { render, staticRenderFns }